import React, { useState } from "react";
import SectionTitle from "../../components/section-title";
import Widget from "../../components/widget";
import logistics from "../../json/logistics"
import Videos from "../../components/dropzone/videos";
import Validation from "../../components/forms/validation";

const Index = () => {
  const [data1, onSubmit1] = useState(null);

  let items = [
    {
      label: "Email",
      error: { required: "Please enter a valid email" },
      name: "email",
      type: "email",
      placeholder: "Enter email of your new coach"
    },
    {
      label: "Name",
      error: { required: "Please enter a valid name" },
      name: "name",
      type: "text",
      placeholder: "Enter name of your coach"
    },
  ];

  return (
    <>
      <SectionTitle title="Training Management" subtitle="Coaching Teams" />

      <Widget
        title="New Coach Registration"
        description={<span>Fill in below form to register new coach to your team</span>}
      >
        <div className="flex flex-col lg:flex-row lg:flex-wrap w-full lg:space-x-4">
          <div className="w-full lg:w-1/2 lg:p-2">
            <Validation items={items} onSubmit={onSubmit1} alerts={false} />
          </div>
          <div className="w-full lg:w-1/2 lg:p-2">
            {data1 && <pre>{JSON.stringify(data1, null, 2)}</pre>}
          </div>
        </div>
      </Widget>
    </>
  );
};
export default Index;
